import { render } from "./TabBar.vue?vue&type=template&id=c2c06150&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=c2c06150&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c06150"]])

export default __exports__